import {makeAutoObservable} from "mobx"
import {api, catchApi} from "../../api"
import {pageLoadingStore} from "../PageLoadingStore";
import {
    DocumentTypeDto,
    ResourceReferencesDto,
    ShipmentListItemDto,
    ShipmentListSortByDto,
    ShipmentPackageStatusDto,
    ShipmentProcessTypeDto,
    ShipmentTypeDto,
    SortTypeDto
} from "../../api/fms";
import {FmsPrinterItem} from "./FmsPrinterStore";
import {isStorageTransferOrInternalProcess} from "./FmsProcessTypeUtil";

class FmsOverviewStore {

    get status(): ShipmentPackageStatusDto[] | undefined {
        return this._status;
    }

    set status(value: ShipmentPackageStatusDto[] | undefined) {
        this._status = value;
    }

    get process(): ShipmentProcessTypeDto[] | undefined {
        return this._process;
    }

    set process(value: ShipmentProcessTypeDto[] | undefined) {
        this._process = value;
    }

    get shipmentType(): ShipmentTypeDto[] | undefined {
        return this._shipmentType;
    }

    set shipmentType(value: ShipmentTypeDto[] | undefined) {
        this._shipmentType = value;
    }

    get documentType(): DocumentTypeDto[] | undefined {
        return this._documentType;
    }

    set documentType(value: DocumentTypeDto[] | undefined) {
        this._documentType = value;
    }

    get customerId(): string | undefined {
        return this._customerId;
    }

    set customerId(value: string | undefined) {
        this._customerId = value;
    }

    get toAbsolute(): string | undefined {
        return this._toAbsolute;
    }

    set toAbsolute(value: string | undefined) {
        this._toAbsolute = value;
    }

    get fromAbsolute(): string | undefined {
        return this._fromAbsolute;
    }

    set fromAbsolute(value: string | undefined) {
        this._fromAbsolute = value;
    }

    get toRelative(): string | undefined {
        return this._toRelative;
    }

    set toRelative(value: string | undefined) {
        this._toRelative = value;
    }

    get fromRelative(): string | undefined {
        return this._fromRelative;
    }

    set fromRelative(value: string | undefined) {
        this._fromRelative = value;
    }

    get q(): string | undefined {
        return this._q;
    }

    set q(value: string | undefined) {
        this._q = value;
    }

    get sortType(): SortTypeDto | undefined {
        return this._sortType;
    }

    set sortType(value: SortTypeDto | undefined) {
        this._sortType = value;
    }

    get sortBy(): ShipmentListSortByDto | undefined {
        return this._sortBy;
    }

    set sortBy(value: ShipmentListSortByDto | undefined) {
        this._sortBy = value;
    }

    get lostOnly(): boolean {
        return this._lostOnly;
    }

    set lostOnly(value: boolean) {
        this._lostOnly = value;
    }

    get page(): number {
        return this._page
    }

    set page(value: number) {
        this._page = value
    }

    get size(): number {
        return this._size
    }

    set size(value: number) {
        this._size = value
    }

    get pages(): number {
        return this._pages
    }

    set pages(value: number) {
        this._pages = value
    }

    get items(): ShipmentListItemDto[] {
        return this._items
    }

    set items(value: ShipmentListItemDto[]) {
        this._items = value
    }

    private _lostOnly: boolean = false
    private _items: ShipmentListItemDto[] = []
    private _pages: number = 0
    private _page: number = 1
    private _size: number = 25


    private _sortBy?: ShipmentListSortByDto
    private _sortType?: SortTypeDto
    private _q?: string
    private _fromRelative?: string
    private _toRelative?: string
    private _fromAbsolute?: string
    private _toAbsolute?: string
    private _customerId?: string
    private _documentType?: DocumentTypeDto[]
    private _shipmentType?: ShipmentTypeDto[]
    private _process?: ShipmentProcessTypeDto[]
    private _status?: ShipmentPackageStatusDto[]

    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        pageLoadingStore.loading = true
        const {
            page,
            size,
            sortBy,
            sortType,
            q,
            fromRelative,
            toRelative,
            fromAbsolute,
            toAbsolute,
            customerId,
            documentType,
            shipmentType,
            process,
            status
        } = this


        const result = await catchApi(async () => await api.fms.api.listShipment({
            lost: this.lostOnly ? true : undefined,
            page: page - 1,
            size,
            sortBy,
            sortType,
            q,
            fromRelative,
            toRelative,
            fromAbsolute,
            toAbsolute,
            customerId,
            documentType,
            shipmentType,
            process,
            status
        }))
        const data = result?.data
        if (data?.items) {
            this.items = data.items
            this.pages = data.totalPages || 0
        } else {
            this.items = []
            this.pages = 0
        }
        pageLoadingStore.loading = false
    }

    async printPicklists({
                             process,
                             shipmentTypes,
                             documentPrinter,
                             vlogPrinter
                         }: {
        process: ShipmentProcessTypeDto,
        shipmentTypes: ShipmentTypeDto[],
        documentPrinter: FmsPrinterItem,
        vlogPrinter: FmsPrinterItem
    }): Promise<ResourceReferencesDto | undefined> {
        const documentPrinterId = documentPrinter?.id
        const labelPrinterId = vlogPrinter?.id || undefined
        const labelPrinterValid = isStorageTransferOrInternalProcess(process) ? true : Boolean(vlogPrinter?.id)
        const shipmentTypeDefined = shipmentTypes && shipmentTypes.length > 0
        if (documentPrinterId && labelPrinterValid && shipmentTypeDefined) {
            const response = await catchApi(async () => await api.fms.api.createPicklists({
                process: process,
                shipmentTypes: shipmentTypes,
                printerId: documentPrinterId,
                labelPrinterId: labelPrinterId
            }));
            return response?.data
        }
    }
}

const fmsOverviewStore = new FmsOverviewStore()

export {
    fmsOverviewStore
}
